export function tiktokIdentifyUser({ email, phone, externalId }) {
  if (!window.ttq) return
  window.ttq.identify({
    email,
    phone_number: phone,
    external_id: externalId,
  })
}

export function tiktokTrackEvent(eventName, params, options) {
  if (!window.ttq) return
  console.log('[tiktok trackEvent]', eventName, params, options)
  window.ttq.track(eventName, params, options)
}
